import { readFile } from "./lib/fsLimit.js";
async function readProjectFile(args) {
  const filePath = args.helpers.joinPathFromRoot(args.filename);
  return await readFile(filePath, args.encoding);
}
export {
  readProjectFile
};
//# sourceMappingURL=readProjectFile.js.map
